/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/453-soundcloud2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM2.75 11h-.5L2 9.5 2.25 8h.5L3 9.5 2.75 11zm2 0h-.5L4 9l.25-2h.5L5 9l-.25 2zm2 0h-.5L6 8l.25-3h.5L7 8l-.25 3zm6.144 0l-4.709-.003a.208.208 0 01-.184-.2V5.403c0-.1.034-.15.162-.2a3 3 0 014.075 2.531 1.701 1.701 0 012.356 1.569c0 .938-.762 1.697-1.7 1.697z"/>'
  }
})
